import { RouteRecordRaw } from "vue-router";

const messageNotifyRouters: RouteRecordRaw[] = [
    {
        path: "/messageNotify",
        name: "MessageNotify",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "消息通知",
            icon: "icon-xiaoxi",
            hidden: true
        },
        redirect: "/messageNotify",
        children: [
            {
                path: "/messageNotify",
                name: "MessageNotify",
                component: () => import("@/views/pages/messageNotify/index.vue"),
                meta: {
                    title: "消息通知",
                    isNotShowHeader: true,
                    hidden: true
                }
            }
        ]
    }
];

export default messageNotifyRouters;
